<template>
  <el-dialog
    title="Добавление тэга"
    :visible.sync="$store.getters.promoActionTagCreateDialog"
    width="30%"
    :before-close="handleClose"
  >
    <el-form>
      <el-form-item label="Название">
        <el-input v-model="title"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$store.commit('promoActionTagCreateDialog', false)"
        >Отмена</el-button
      >
      <el-button type="primary" :disabled="disableButton" @click="saveTag"
        >Добавить</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";

export default {
  name: "CreatePromoActionTagDialog",
  props: ["dialogVisible3"],
  data: function () {
    return {
      title: "",
    };
  },
  computed: {
    disableButton() {
      if (this.title === "") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    handleClose() {
      this.$store.commit("promoActionTagCreateDialog", false);
    },
    saveTag() {
      let data = {
        title: this.title,
      };

      axios
        .post("/promo-action/tag", data)
        .then((response) => {
          const tag = response.data;

          this.$emit("updateParent", tag);
          this.$store.commit("promoActionTagCreateDialog", false);
          this.title = "";
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
  },
};
</script>

<style scoped>
</style>